import { render } from "./subcategory-model.vue?vue&type=template&id=37fe8b15"
import script from "./subcategory-model.vue?vue&type=script&lang=js"
export * from "./subcategory-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__